import { LanguageContext } from '@/context/LanguageContext';
import { BuildPath } from  '@/helpers/Paths';
import React, { useContext } from 'react';

const ProgressBar = ({currentProgress, setCurrentProgress}: {currentProgress:number, setCurrentProgress:(number) => void}) => {

    const languageContext = useContext(LanguageContext);
    
    function image(stage:number){

        switch (stage) {
            case 1:

                // Complete
                if (currentProgress > 1){
                    return "/images/dct/arrow/arrow-1.2.svg" 
                }

                return "/images/dct/arrow/arrow-1.1.svg"
            case 2:

                // Complete
                if (currentProgress > 2){
                    return "/images/dct/arrow/arrow-2.3.svg" 
                }

                // Active
                if (currentProgress === 2){
                    return "/images/dct/arrow/arrow-2.2.svg" 
                }

                // Un-active
                return "/images/dct/arrow/arrow-2.1.svg"
            case 3:

                // Active
                if (currentProgress === 3){
                    return "/images/dct/arrow/arrow-3.2.svg" 
                }

                // Un-active
                return "/images/dct/arrow/arrow-3.1.svg"       
        }

    }

    function boxClass(stage:number){

        switch (stage) {
            case 1:

                // Complete
                if (currentProgress > 1){
                    return "complete" 
                }

                return "active"
            case 2:

                // Complete
                if (currentProgress > 2){
                    return "complete" 
                }

                // Active
                if (currentProgress === 2){
                    return "active" 
                }

                // Un-active
                return "unactive"
            case 3:

                // Active
                if (currentProgress === 3){
                    return "active" 
                }

                // Un-active
                return "unactive"       
        }

    }

    function move(stage:number){

        switch (stage) {
            case 1:
                setCurrentProgress(1)
                break;
            case 2:
                if (languageContext.store.languageSelected.length){
                    setCurrentProgress(2)  
                }  
                break;    
            case 3:
            
                if (languageContext.store.translateScope !== null){
                    setCurrentProgress(3)
                }
                break; 
        }

    }

    return (
        <div className='progress-bar'>

            <div className={boxClass(1)} onClick={() => move(1)}>
                <img src={`${BuildPath()}${image(1)}`} alt="Language Selection<" />
                <span>Language Selection</span>
            </div>

            <div className={boxClass(2)}  onClick={() => move(2)}>
                <img src={`${BuildPath()}${image(2)}`} alt="Language Action" />
                <span>Language Action</span>
            </div>

            <div className={boxClass(3)}  onClick={() => move(3)}>
                <img src={`${BuildPath()}${image(3)}`} alt="Review" />
                <span>Review</span>
            </div>
            
        </div>

    );
};

export default ProgressBar;